import { Component, OnInit, ViewChild } from '@angular/core';
import { NotificationType } from 'src/app/models/notification.message';
import { VendorRequest } from 'src/app/models/requests/vendor-request';
import { VendorsService } from 'src/app/services/vendors.service';
import { NotificationService } from 'src/app/services/notification.service';
import { contractorType } from 'src/app/models/ContractorType';

@Component({
  selector: 'app-new-vendor',
  templateUrl: './new-vendor.component.html',
  styleUrls: ['./new-vendor.component.css']
})
export class NewVendorComponent {

  @ViewChild('ngNewVendorForm') theForm:any;
  ContractorType = contractorType;

  name: string = '';
  description: string = '';
  phone: string = '';
  email: string = '';
  address: string = '';
  selectedContractType: string = '';
  contactPerson: string = ''
  ContactPersonEmail:string='';


  constructor(private vendorService: VendorsService, private notification: NotificationService) { }


  onSubmit(): void {
    let VendorVm: VendorRequest = {
      Id:0,
      Name: this.name,
      Description: this.description,
      Phone: this.phone,
      Email: this.email,
      Address: this.address,
      ContactPerson: this.contactPerson,
      ContactPersonEmail :this.ContactPersonEmail,
      contractorType: this.selectedContractType
    };

    this.vendorService.saveVendors(VendorVm).subscribe({
      next: (data => {
        
        if (data.responseCode == "00") {
          this.notification.sendMessage({
            message: data.message,
            type: NotificationType.success
          });

          console.debug(`Vendor Created successfully ${data}`);

          this.theForm.resetForm();

        }
        else {

          this.notification.sendMessage({
            message: data.message,
            type: NotificationType.error
          });

        }

      }),
      error: ((error: any) => {
        console.log(error.error);
        ;


        this.notification.sendMessage({
          message: error.error.message,
          type: NotificationType.error
        });
      })

    });
  }
}
